export const DUPLICATE_USERNAME_ERROR = 'Username already exists, please try again'

export const normalizeUsername = (username: string): string => username.trim().toLowerCase()

export const isUsernameRelatedError = (error: unknown): boolean => {
  const status = (error as { response?: { status?: number } })?.response?.status
  const message = ((error as { message?: string })?.message ?? '').toLowerCase()
  return status === 409 || message.includes('username') || message.includes('taken') || message.includes('exists')
}

export const parseUsernameUpdateError = (error: unknown, defaultMessage = DUPLICATE_USERNAME_ERROR): string => {
  let message: string | undefined
  if (error && typeof error === 'object' && 'response' in error) {
    const apiError = error as { response?: { data?: { message?: string } } }
    if (apiError.response?.data?.message) {
      message = apiError.response.data.message
    }
  }
  if (!message && error && typeof error === 'object' && 'message' in error) {
    message = (error as { message: string }).message
  }
  if (message && isUsernameRelatedError({ message })) {
    return DUPLICATE_USERNAME_ERROR
  }
  return message ?? defaultMessage
}
